import { render, staticRenderFns } from "./BookingAdminOptions.vue?vue&type=template&id=67e6ed46"
import script from "./BookingAdminOptions.vue?vue&type=script&lang=js"
export * from "./BookingAdminOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports